var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#EB0043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7541 15.5671L12.1831 10.9961L16.7421 6.42411C16.9006 6.26466 16.9896 6.04895 16.9896 5.82411C16.9896 5.59926 16.9006 5.38356 16.7421 5.22411C16.5828 5.07236 16.3705 4.98896 16.1505 4.99177C15.9306 4.99457 15.7204 5.08335 15.5651 5.23911L11.0001 9.81211L6.4301 5.24211C6.2719 5.08523 6.05786 4.99763 5.83506 4.99856C5.61227 4.9995 5.39898 5.0889 5.2421 5.24711C5.08522 5.40531 4.99762 5.61935 4.99856 5.84214C4.9995 6.06493 5.0889 6.27823 5.2471 6.43511L9.8171 10.9951L5.2411 15.5721C5.08436 15.7304 4.99693 15.9446 4.99806 16.1673C4.99918 16.3901 5.08877 16.6034 5.2471 16.7601C5.40543 16.9169 5.61955 17.0043 5.84234 17.0031C6.06514 17.002 6.27836 16.9124 6.4351 16.7541L11.0011 12.1801L15.5721 16.7411C15.7329 16.897 15.9481 16.9842 16.1721 16.9842C16.3961 16.9842 16.6113 16.897 16.7721 16.7411C16.9226 16.5816 17.0048 16.3697 17.0015 16.1505C16.9981 15.9312 16.9094 15.7219 16.7541 15.5671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.9edf5ebb77ca81bd1f7a40e812ed6142.svg";
export { ForwardRef as ReactComponent };